import { JsonObject } from 'json2typescript';

@JsonObject('CartItem')
export default abstract class CartItem {
  constructor() {
    this.cartItemId = 0;
    this.quantity = 0;
    this.examFeeType = '';
    this.canBuy = false;
    this.resourceUri = '';
    this.alternativeText = '';
    this.fees = [];
    this.periodStart = '';
    this.periodEnd = '';
    this.serialCodes = [];
  }

  public abstract get code(): string;

  public abstract set code(v: string);

  public abstract get title(): string;

  public abstract set title(v: string);

  public abstract get options(): Array<{typeTitle: string; title: string}>;

  public cartItemId: number;

  public quantity: number;

  public examFeeType: string;

  public canBuy: boolean;

  public registrationRequired: boolean;

  public resourceUri: string;

  public alternativeText: string;

  public fees: number[];

  public totalFee: number;

  public periodStart: string;

  public periodEnd: string;

  /** 表示用 */
  public serialCodes: string[];
}
